const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
let cartDrawerElement = document.querySelector(".cart-drawer");
let cartDrawerOpener = document.querySelector(".cart-drawer-opener");
document.querySelector(".close-cart-drawer");
document.querySelector(".cart-background");
class cartDrawer {
  constructor() {
    var _this = this;
    document.addEventListener("rebuy:smartcart.ready", function(event) {
      event.detail.smartcart;
      if (cartDrawerElement) {
        if (cartDrawerOpener) {
          cartDrawerOpener.addEventListener("click", _this.openCartDrawer);
        }
      }
    });
  }
  /**
   * Get current state of the cart drawer.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState() {
    if (cartDrawerElement.classList.contains("js-drawer-open")) {
      return {
        state: "open",
        isCartOpen: true
      };
    } else {
      return {
        state: "closed",
        isCartOpen: false
      };
    }
  }
  /**
   * Open cart drawer.
   */
  openCartDrawer() {
    var SmartCart = window.Rebuy.SmartCart;
    SmartCart.show();
    bodyLock.lock();
    cartDrawer.hideOnClickOutside(cartDrawerElement);
  }
  /**
   * Close cart drawer.
   */
  static closeCartDrawer() {
    bodyLock.unlock();
  }
  /**
   * Handle open cart drawer.
   */
  handleOpenCartDrawer() {
    let currentState = this.getCurrentState();
    if (currentState.isCartOpen) {
      cartDrawer.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }
  /**
   * Close the cart drawer when clicked outside the cart drawer.
   */
  static hideOnClickOutside() {
    var _this2 = this;
    const outsideClickListener = (event) => {
      let target = event.target;
      if (target !== cartDrawerElement && target.closest(".cart-drawer") || target.closest(".cart-drawer-opener") === cartDrawerOpener) ;
      else {
        _this2.closeCartDrawer();
        removeClickListener();
      }
    };
    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener);
    };
    document.addEventListener("click", outsideClickListener);
  }
}
var cartDrawer$1 = new cartDrawer();
export {
  cartDrawer$1 as default
};
